/**
 * MIRA Table Component
 * Wraps Shadcn Table with MIRA design system styles
 */

import React from 'react';
import {
  Table as ShadcnTable,
  TableHeader as ShadcnTableHeader,
  TableBody as ShadcnTableBody,
  TableFooter as ShadcnTableFooter,
  TableHead as ShadcnTableHead,
  TableRow as ShadcnTableRow,
  TableCell as ShadcnTableCell,
  TableCaption as ShadcnTableCaption,
} from '@/components/ui/table';
import { cn } from '@/lib/utils';
import styles from '@/styles/components/data-display/table.module.css';

export const Table = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTable
        ref={ref}
        className={cn(styles.miraTable, className)}
        {...props}
      />
    );
  }
);

Table.displayName = 'MiraTable';

export const TableHeader = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableHeader
        ref={ref}
        className={cn(styles.miraTableHeader, className)}
        {...props}
      />
    );
  }
);

TableHeader.displayName = 'MiraTableHeader';

export const TableBody = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableBody
        ref={ref}
        className={cn(styles.miraTableBody, className)}
        {...props}
      />
    );
  }
);

TableBody.displayName = 'MiraTableBody';

export const TableFooter = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableFooter
        ref={ref}
        className={cn(styles.miraTableFooter, className)}
        {...props}
      />
    );
  }
);

TableFooter.displayName = 'MiraTableFooter';

export const TableRow = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableRow
        ref={ref}
        className={cn(styles.miraTableRow, className)}
        {...props}
      />
    );
  }
);

TableRow.displayName = 'MiraTableRow';

export const TableHead = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableHead
        ref={ref}
        className={cn(styles.miraTableHead, className)}
        {...props}
      />
    );
  }
);

TableHead.displayName = 'MiraTableHead';

export const TableCell = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableCell
        ref={ref}
        className={cn(styles.miraTableCell, className)}
        {...props}
      />
    );
  }
);

TableCell.displayName = 'MiraTableCell';

export const TableCaption = React.forwardRef(
  ({ className, ...props }, ref) => {
    return (
      <ShadcnTableCaption
        ref={ref}
        className={cn(styles.miraTableCaption, className)}
        {...props}
      />
    );
  }
);

TableCaption.displayName = 'MiraTableCaption';
